// ==================== CategoryBreadCrumb.jsx ====================
import { Link } from "react-router-dom";

const CategoryBreadcrumb = ({ categoryFullPath, categorySlugFullPath }) => {
  const buildCategoryBreadcrumb = (fullPath, slugPath) => {
    if (!fullPath || !slugPath) return [];
    const names = fullPath.split(" / ");
    const slugs = slugPath.split(" / ");
    return names.map((name, index) => ({
      label: name,
      slug: slugs[index],
    }));
  };

  const items = buildCategoryBreadcrumb(categoryFullPath, categorySlugFullPath);

  if (!items.length) return null;

  return (
    <nav className="text-xs md:text-sm text-gray-500">
      <ul className="flex items-center gap-1.5 md:gap-2 whitespace-nowrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.slug} className="flex items-center gap-1.5 md:gap-2 shrink-0">
              <Link
                to={`/shopping/product-list/?category_slug=${item.slug}`}
                className={`transition hover:text-[#1E3A5F] ${
                  isLast ? "text-gray-800 font-medium" : "text-gray-500"
                }`}
              >
                {item.label}
              </Link>
              {!isLast && <span className="text-gray-300">/</span>}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default CategoryBreadcrumb;